<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-card header="Bookmakers">
            <div class="filter-bar ui basic segment grid">
              <div class="ui form">
                <div class="inline field">
                  <label>Search for:</label>
                  <input type="text" v-model="filterText" class="three wide column" @keyup.enter="doFilter" placeholder="code, description, bookmaker">
                  <button class="ui primary button" @click="doFilter">Go</button>
                  <button class="ui button" @click="resetFilter">Reset</button>
                </div>
              </div>
            </div>
            <vuetable :multi-sort="true" multi-sort-key="ctrl" ref="vuetable" :api-url="api_url" :fields="fields" pagination-path="" :per-page="perPage" @vuetable:pagination-data="onPaginationData" :append-params="moreParams" :http-options="httpOptions">
              <template slot="actions" slot-scope="props">
                <div class="table-button-container">
                  <button class="btn btn-info" @click="editBookmaker(props.rowData)"><i class="fa fa-edit"></i> Edit</button>&nbsp;&nbsp;
                  <button class="btn btn-danger" @click="deleteBookmaker(props.rowData._id)"><i class="fa fa-remove"></i> Delete</button>&nbsp;&nbsp;
                </div>
              </template>
            </vuetable>
            <div class="vuetable-pagination ui basic segment grid">
              <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>
              <vuetable-pagination ref="pagination" @vuetable-pagination:change-page="onChangePage"></vuetable-pagination>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card header="Add a new Bookmaker">
            <form action="#" method="POST" class="createBookmaker">
              <div class="form-group">
                <label >Bookmaker Name:</label>
                <input @click='getMaxBookmakerCode()' class="form-control" type="text" placeholder="Ex: betzest" required="required" v-model="bookmakerName">
              </div>
              <div class="form-group">
                <label for="#bkmCode">Bookmaker Code:</label>
                <input class="form-control" type="number" placeholder="Ex: 2" required="required" v-model="bookmakerCode">
              </div>
              <div class="form-group">
                <label for="#bkmDescription">Bookmaker Description:</label>
                <textarea class="form-control" id="bkmDescription" v-model="bookmakerDescription"></textarea>
              </div>
              <div class="form-group">
                <label for="#bkmRestrictedCountries">Restricted Coumtries:</label>
                <textarea class="form-control" id="bkmCountryRestriction" v-model="restrictedCountries"></textarea>
              </div>
              <div class="form-group">
                <button type="submit" class="btn btn-secondary form-control" @click.prevent="saveBookmaker">Save</button>
              </div>
            </form>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <!-- <add-a-new-bookmaker></add-a-new-bookmaker> -->
    <edit-bookmaker-modal></edit-bookmaker-modal>
  </div>
</template>

<script>

import Vue from 'vue'
import { Bus } from '@/main'
import Vuetable from 'vuetable-2/src/components/Vuetable'
import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
import collect from 'collect.js'
// import AddBookmakerModal from '@/views/modals/AddBookmakerModal'
import EditBookmakerModal from '@/views/modals/EditBookmakerModal'

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    // 'add-a-new-bookmaker': AddBookmakerModal,
    'edit-bookmaker-modal': EditBookmakerModal
  },
  data () {
    return {
      httpOptions: {
        baseURL: this.$http.defaults.baseURL,
        headers: this.$http.defaults.headers.common
      },
      perPage: 10,
      bookmakerName: '',
      bookmakerCode: '',
      bookmakerDescription: '',
      bookmakers: [],
      moreParams: {},
      filterText: '',
      restrictedCountries: [],

      fields: [
        {
          name: '__sequence', // <----
          title: '#',
          titleClass: 'center aligned',
          dataClass: 'right aligned'
        },
        {
          name: 'name',
          title: 'Bookmaker Name',
          sortField: 'name'
        },
        {
          name: 'code',
          title: 'Code',
          sortField: 'code'
        },
        {
          name: 'description',
          title: 'Description'
        },
        {
          name: 'restricted_countries',
          title: 'Restricted Countries'
        },
        {
          name: 'created_at',
          title: 'Created',
          sortField: 'created_at',
          callback: 'formatDate'
        },
        {
          name: '__slot:actions',
          title: 'Actions',
          titleClass: 'text-center',
          dataClass: 'text-center'
        }

      ],
      api_url: '',
      sortOrder: [
        {
          field: 'created_at',
          sortField: 'created_at',
          direction: 'desc'
        }
      ]
    }
  },
  methods: {
    formatDate (value, fmt = 'D MMM YYYY') {
      return (value === null)
        ? ''
        : this.$moment(value, 'YYYY-MM-DD').format(fmt)
    },
    formatActions (value) {
      return `<i ref="delete_${value}" @click="console.log('test')" class="fas fa-trash-alt"></i>`
    },
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData) // <----
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    reloadTable () {
      this.$refs.vuetable.refresh()
    },
    deleteBookmaker (id) {
      if (prompt('Are you sure? Type "delete" if yes!') === 'delete') {
        this.$http.delete(`${this.$api_url}/bookmakers/delete/${id}`, { id: id }).then((success) => {
          this.reloadTable()
          alert('Bookmaker code deleted!')
        })
      } else {
        alert('Bookmaker code not deleted!')
      }
    },
    editBookmaker (data) {
      Bus.$emit('editBookmaker', data)
      this.$bvModal.show('bookmaker-edit')
    },
    doFilter () {
      this.moreParams = {
        filter: this.filterText
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    resetFilter () {
      this.filterText = ''
      this.moreParams = {}
      Vue.nextTick(() => this.$refs.vuetable.refresh())
    },
    saveBookmaker () {
      if (this.bookmakerName && this.bookmakerCode) {
        this.$http.post(`${this.$api_url}/bookmakers/create`, { name: this.bookmakerName.toString(), code: this.bookmakerCode, description: this.bookmakerDescription, restricted_countries: this.restrictedCountries }).then((success, error) => {
          if (success) {
            this.reloadTable()
            this.bookmakerDescription = ''
            this.bookmakerName = ''
            this.bookmakerCode = ''
            this.restrictedCountries = ''
          }
          if (error) {
            alert('Duplicate Bookmaker code!')
          }
        })
      }
    },
    getMaxBookmakerCode () {
      this.$http.get(`${this.$api_url}/bookmakers/all`).then((bookmakers) => {
        if (bookmakers) {
          bookmakers = bookmakers.data
          let maxCode = collect(bookmakers).max('code') || 0
          maxCode = maxCode === '-Infinity' ? 0 : maxCode
          this.bookmakerCode = maxCode + 1
        } else {
          this.bookmakerCode = 1
        }
      })
    }
  },
  created () {
    this.api_url = `${this.$api_url}/bookmakers`
    Bus.$on('bookmakerUpdated', ({ _id }) => {
      this.reloadTable()
    })
  },
  beforeDestroy () {
    Bus.$off('bookmakerUpdated')
  }
}
</script>

<style scoped>

</style>
